import { render, staticRenderFns } from "./display-field-tppwb-sync.vue?vue&type=template&id=18cf4755&scoped=true&"
import script from "./display-field-tppwb-sync.vue?vue&type=script&lang=ts&"
export * from "./display-field-tppwb-sync.vue?vue&type=script&lang=ts&"
import style0 from "./display-field-tppwb-sync.vue?vue&type=style&index=0&id=18cf4755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cf4755",
  null
  
)

export default component.exports